module.exports = __webpack_public_path__ + "static/media/12.41c2903f.jpg";